import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from './toastr.service';

export enum HttpError {
  BadRequest = 400,
  Unauthorised = 401,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  Validation = 409,
  InternalServerError = 500
}

@Injectable({
  providedIn: 'root'
})
export class HttpErrorHandlerService {
  constructor(private toastr: ToastrService) {}

  public handleError(status: HttpError, error: HttpErrorResponse) {
    if (!error || !error.error || error.error.handled) {
      return;
    }
    switch (status) {
      case HttpError.InternalServerError:
        this.toastr.error('Server error occurred. Please contact the administrator.', 0, true);
        break;

      case HttpError.Forbidden:
        this.toastr.error('Access denied.');
        break;

      case HttpError.Validation:
        this.toastr.error(error.error.message);
        break;

      case HttpError.MethodNotAllowed:
        this.toastr.error('Method not allowed.');
        break;
    }
  }
}
